import { render } from "./ShareProjectModal.vue?vue&type=template&id=3fb3d4d8&scoped=true&ts=true"
import script from "./ShareProjectModal.vue?vue&type=script&lang=ts"
export * from "./ShareProjectModal.vue?vue&type=script&lang=ts"

import "./ShareProjectModal.vue?vue&type=style&index=0&id=3fb3d4d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb3d4d8"]])

export default __exports__